import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";


const firebaseConfig = {
  apiKey: "AIzaSyCjLVbpTAil6OlEjYNvznS7vWNzxUBIOx0",
  authDomain: "genstoryflow.firebaseapp.com",
  projectId: "genstoryflow",
  storageBucket: "genstoryflow.firebasestorage.app",
  messagingSenderId: "353838813175",
  appId: "1:353838813175:web:367fe68f01ba8ef4dc68f2",
  measurementId: "G-NND087C3BB"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);